import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    cardDeactivationLabel: 'Deactivation date',
    confirm: 'Confirm',
    labels: {
      dateInDays: 'In {0} days',
      dateInMonth: 'In 1 month',
      the: 'On the ',
      tomorrow: 'Tomorrow',
    },
    permanentCardDescription:
      'Add an automatic deactivation date to this virtual card.',
    temporaryCardDescription:
      'This virtual card will be automatically deactivated on {0}',
  },
  fr: {
    cancel: 'Annuler',
    cardDeactivationLabel: 'Date de désactivation',
    confirm: 'Confirmer',
    labels: {
      dateInDays: 'Dans {0} jours',
      dateInMonth: 'Dans 1 mois',
      the: 'Le ',
      tomorrow: 'Demain',
    },
    permanentCardDescription:
      'Ajouter une date de désactivation automatique à cette carte virtuelle.',
    temporaryCardDescription:
      'Cette carte sera automatiquement désactivée le {0}',
  },
} as const);

export default locales;
